import React, { useEffect, useRef, useState } from "react";
import { Card, Button, Breadcrumb, Affix, Typography } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../Common/Header";
import { isMobileView } from "../../Common/AppHelper";
import AddOrUpdateForm from "./AddOrUpdateForm";
import { getData } from "../../../apiServices/common";

const ViewBOM = (props) => {
  // Props
  const { width } = props;

  // States
  const [permitInfo, setPermitInfo] = useState();

  // Antd
  const { Title } = Typography;

  // Others
  let { styleId } = useParams();
  const propertyFormRef = useRef(null);
  const navigate = useNavigate();
  const discartForm = () => {
    navigate("/merchandising/BOM");
  };
  const edit_url = `/api/bill_of_material/${styleId}/edit`;

  const getPIInfo = async () => {
    let res = await getData(edit_url);

    if (res) {
      let masterData = res.data.data;
      setPermitInfo(masterData);
    }
  };

  useEffect(() => {
    getPIInfo();
  }, []);

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title={<Title level={5}>View Bill of Materials</Title>}
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discartForm()}>
                Back
              </Button>,
            ]}
          ></Header>
        </Card>
      </Affix>

      <AddOrUpdateForm
        ref={propertyFormRef}
        permitInfo={permitInfo}
        view={true}
      />
    </>
  );
};

export default ViewBOM;
